<template>
  <section>
    <div v-if='files.length >= 2'>
      <b-collapse class="card" :open.sync="isOpen">
          <div slot="trigger" class="card-header">
              <p class="card-header-title">
                  <b-icon icon='folder-multiple-image'></b-icon> &nbsp;&nbsp; {{ label }}
              </p>
              <a class="card-header-icon">
                  <b-icon :icon="isOpen ?
                      'menu-down' : 'menu-up'">
                  </b-icon>
              </a>
          </div>
          <div class="card-content">

            <b-field label='Звук' v-if='files.indexOf("audio") >= 0'>
              <div v-if='progress.audio.loading'>
                <b-field class="notification" label='Загрузка'>
                  <n3-progress class="margin">
                    <n3-progressbar :now="progress.audio.p" type="success" height="10px"></n3-progressbar>
                  </n3-progress>
                </b-field>
              </div>
              <div v-else>
                <b-field v-if='value.audio.name === ""'>
                  <b-upload v-model='audio_file' drag-drop class='is-full-width' @input='audio_input'>
                    <div class='content has-text-centered'>
                      <b-icon icon='upload'></b-icon> Перетащите файл сюда.
                    </div>
                  </b-upload>
                </b-field>
                <b-field v-else>
                  <b-notification @close='delete_audio'>
                    <button @click='preview_audio(value.audio.filename)'>
                      <b-icon icon='presentation-play' size='is_small'></b-icon>
                    </button> &nbsp;&nbsp; {{ value.audio.name }}
                  </b-notification>
                </b-field>
              </div>
            </b-field>

            <b-field label='Картинка' v-if='files.indexOf("image") >= 0'>
              <div v-if='progress.image.loading'>
                <b-field class="notification" label='Загрузка'>
                  <n3-progress class="margin">
                    <n3-progressbar :now="progress.image.p" type="success" height="10px"></n3-progressbar>
                  </n3-progress>
                </b-field>
              </div>
              <div v-else>
                <b-field v-if='value.image.name === ""'>
                  <b-upload v-model='image_file' drag-drop class='is-full-width' @input='image_input'>
                    <div class='content has-text-centered'>
                      <b-icon icon='upload'></b-icon> Перетащите файл сюда.
                    </div>
                  </b-upload>
                </b-field>
                <b-field v-else>
                  <b-notification @close='delete_image'>
                    <button @click='preview_image(value.image.filename)'>
                      <b-icon icon='presentation-play' size='is_small'></b-icon>
                    </button> &nbsp;&nbsp; {{ value.image.name }}
                  </b-notification>
                </b-field>
              </div>
            </b-field>

            <b-field label='Видео' v-if='files.indexOf("video") >= 0'>
              <div v-if='progress.video.loading'>
                <b-field class="notification" label='Загрузка'>
                  <n3-progress class="margin">
                    <n3-progressbar :now="progress.video.p" type="success" height="10px"></n3-progressbar>
                  </n3-progress>
                </b-field>
              </div>
              <div v-else>
                <b-field v-if='value.video.name === ""'>
                  <b-upload v-model='video_file' drag-drop class='is-full-width' @input='video_input'>
                    <div class='content has-text-centered'>
                      <b-icon icon='upload'></b-icon> Перетащите файл сюда.
                    </div>
                  </b-upload>
                </b-field>
                <b-field v-else>
                  <b-notification @close='delete_video'>
                    <button @click='preview_video(value.video.filename)'>
                      <b-icon icon='presentation-play' size='is_small'></b-icon>
                    </button> &nbsp;&nbsp; {{ value.video.name }}
                  </b-notification>
                </b-field>
              </div>
            </b-field>
          </div>
         <!--  <footer class="card-footer">
              <a class="card-footer-item">Сохранить</a>
              <a class="card-footer-item">Удалить все</a>
          </footer> -->
      </b-collapse>
    </div>

    <div v-if='files.length === 1'>

      <b-field :label='label' v-if='files.indexOf("audio") >= 0'>
        <b-field v-if='value.audio.name === ""'>
          <b-upload v-model='audio_file' drag-drop class='is-full-width' @input='audio_input'>
            <div class='content has-text-centered'>
              <b-icon icon='upload'></b-icon> Перетащите файл сюда.
            </div>
          </b-upload>
        </b-field>
        <b-field v-else>
          <b-notification @close='delete_audio'>
            {{ value.audio.name }}
          </b-notification>
        </b-field>
      </b-field>

      <b-field :label='label' v-if='files.indexOf("image") >= 0'>
        <b-field v-if='value.image.name === ""'>
          <b-upload v-model='image_file' drag-drop class='is-full-width' @input='image_input'>
            <div class='content has-text-centered'>
              <b-icon icon='upload'></b-icon> Перетащите файл сюда.
            </div>
          </b-upload>
        </b-field>
        <b-field v-else>
          <b-notification @close='delete_image'>
            {{ value.image.name }}
          </b-notification>
        </b-field>
      </b-field>

      <b-field :label='label' v-if='files.indexOf("video") >= 0'>
        <b-field v-if='value.video.name === ""'>
          <b-upload v-model='video_file' drag-drop class='is-full-width' @input='video_input'>
            <div class='content has-text-centered'>
              <b-icon icon='upload'></b-icon> Перетащите файл сюда.
            </div>
          </b-upload>
        </b-field>
        <b-field v-else>
          <b-notification @close='delete_video'>
            {{ value.video.name }}
          </b-notification>
        </b-field>
      </b-field>

    </div>
  </section>
</template>

<script>
  export default {
    name: 'mediaUploader',
    props: {
      label: String,
      value: {
        type: Object,
        default: function () {
          return this.empty_media
        }
      },
      files: {
        type: Array,
        default: function () {
          return ['audio', 'image', 'video']
        }
      },
      disabled: Boolean
    },
    data: function () {
      return {
        audio_file: [],
        image_file: [],
        video_file: [],
        progress: {'audio': {loading: false, p: 0}, 'image': {loading: false, p: 0}, 'video': {loading: false, p: 0}},
        empty_file: {name: '', filename: '', filetype: '', filesize: 0},
        empty_media: {audio: {name: '', filename: '', filetype: '', filesize: 0}, video: {name: '', filename: '', filetype: '', filesize: 0}, image: {name: '', filename: '', filetype: '', filesize: 0}},
        isOpen: false
      }
    },
    methods: {
      audio_input: function (str) {
        // console.log(str, this.audio_file, this.value)
        // this.value.audio.name = this.audio_file[0].name
        // this.$emit('input', this.value)
        this.upload(this.audio_file[0], 'audio')
      },
      image_input: function (str) {
        // console.log(str, this.image_file, this.value)
        // this.value.image.name = this.image_file[0].name
        // this.$emit('input', this.value)
        this.upload(this.image_file[0], 'image')
      },
      video_input: function (str) {
        // console.log(str, this.video_file, this.value)
        // this.value.video.name = this.video_file[0].name
        // this.$emit('input', this.value)
        this.upload(this.video_file[0], 'video')
      },
      delete_audio: function () {
        this.value.audio = this.empty_file
        this.$emit('input', this.value)
      },
      delete_image: function () {
        this.value.image = this.empty_file
        this.$emit('input', this.value)
      },
      delete_video: function () {
        this.value.video = this.empty_file
        this.$emit('input', this.value)
      },
      upload: function (file, type) {
        var _this = this
        var xhr = new XMLHttpRequest()
        _this.progress[type].p = 0
        _this.progress[type].loading = true
        xhr.open('PUT', window.gw + 'api/upload/' + file.name, true)
        xhr.setRequestHeader('Content-Type', file.type)
        xhr.setRequestHeader('Content-Range', `bytes 0-${file.size - 1}/${file.size}`)
        console.log('template', `bytes 0-${file.size - 1}/${file.size}`, file)

        if (xhr.upload) {
          xhr.upload.addEventListener('progress', (e) => {
            var percent = (e.loaded / e.total) * 100
            var p = parseFloat(percent).toFixed(0)
            _this.progress[type].p = p
          })
        }

        xhr.onload = (e) => {
          console.log('upload complete', e)
          var d = JSON.parse(e.currentTarget.response)
          if (d.result === 'ok') {
            var f = d.params.file
            _this.value[type].name = f.real_filename
            _this.value[type].filename = f.filename
            _this.value[type].filesize = f.filesize
            _this.value[type].filetype = f.filetype
            _this.$emit('input', _this.value)
            console.log(_this.value)
          }
          _this.progress[type].loading = false
        }
        xhr.onerror = (e) => {
          console.log('upload error', e)
          _this.progress[type].loading = false
        }
        xhr.send(file)
      }, // upload
      preview_image: function (img) {
        img = '/uploads/' + img
        this.$modal.open('<p class="image"><img src="' + img + '" volume="0.2" /></p>')
      },
      preview_audio: function (audio) {
        audio = '/uploads/' + audio
        this.$modal.open('<p><audio controls><source src="' + audio + '" volume="0.2" /></audio></p>')
      },
      preview_video: function (video) {
        video = '/uploads/' + video
        this.$modal.open('<p><video controls><source src="' + video + '" volume="0.2" /></audio></p>')
      }
    },
    watch: {
      value: function (value) {
        this.value = value
        console.log('value', value)
      },
      newValue: function (value) {
        if (value === this.value) {
          this.$emit('input', value)
          console.log('new_value', value)
        }
      }
    }
  }
</script>

<style scoped>
  .is-full-width { 
    width: 100%; 
  }
  .upload-draggable {
    width: 100%;
    height: 30px;
  }
</style>


// WEBPACK FOOTER //
// src/components/MediaContainer.vue